import { render, staticRenderFns } from "./SelectAccreditationForm.vue?vue&type=template&id=4fab26cc"
import script from "./SelectAccreditationForm.vue?vue&type=script&lang=js"
export * from "./SelectAccreditationForm.vue?vue&type=script&lang=js"
import style0 from "./SelectAccreditationForm.vue?vue&type=style&index=0&id=4fab26cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports